export const PaginationDefaults = {
  EVENTS_LIMIT: 25,
  REQUESTS_LIMIT: 25,
  WEBHOOKS_LIMIT: 25,
};

export const HOME_ROUTE = '/events';
